module.exports = __webpack_public_path__ + "teqbahn-assets/media/tilli_new.ad298bf5.png";